import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index.vue'
// import SelectType from '@/components/SelectType.vue'
import RealCards from '@/components/RealCards.vue'
import RealResult from '@/components/RealResult.vue'
import CorpClients from '@/components/CorpClients.vue'
import VirtualCards from '@/components/VirtualCards.vue'
// import VirtualCardsNew from '@/components/VirtualCards_NewPhoneField.vue'
import VirtualResult from '@/components/VirtualResult.vue'
import ModalDelete from '@/components/ModalDelete.vue'
import ModalCity from '@/components/ModalCity.vue'
import ModalError from '@/components/ModalError.vue'
import Activation from '@/components/Activation.vue'

const redirrectURL = 'https://goldapple.by/cards'

// const VirtualCards = resolve => {
//   require.ensure([], () => {
//     resolve(require('components/VirtualCards.vue'))
//   }, 'VirtualCards')
// }

// const RealResult = resolve => {
//   require.ensure([], () => {
//     resolve(require('components/RealResult.vue'))
//   }, 'RealResult')
// }

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      beforeEnter (to, from, next) {
        window.location.href = redirrectURL
      }
    },
    {
      path: '/select',
      name: 'SelectType',
      component: Index,
      beforeEnter (to, from, next) {
        window.location.href = redirrectURL
      }
    },
    {
      path: '/real',
      name: 'RealCards',
      component: RealCards
    },
    {
      path: '/virtual',
      name: 'VirtualCards',
      component: VirtualCards,
      beforeEnter (to, from, next) {
        window.location.href = `${redirrectURL}#gift-cards`
      }
    },
    {
      path: '/corporative',
      name: 'CorpClients',
      component: CorpClients
    },
    {
      path: '/real/result',
      name: 'RealResult',
      component: RealResult
    },
    {
      path: '/virtual/result',
      name: 'VirtualResult',
      component: VirtualResult
    },
    {
      path: '/modal/delete',
      name: 'ModalDelete',
      component: ModalDelete
    },
    {
      path: '/modal/city',
      name: 'ModalCity',
      component: ModalCity
    },
    {
      path: '/modal/error',
      name: 'ModalError',
      component: ModalError
    },
    {
      path: '/activation',
      name: 'Activation',
      component: Activation
    },
    {
      path: '*',
      component: Index,
      beforeEnter (to, from, next) {
        window.location.href = redirrectURL
      }
    }
  ]
})

const cleanRoutes = ['RealResult', 'VirtualResult', 'ModalError']

router.beforeEach((to, from, next) => {
  if (cleanRoutes.indexOf(to.name) === -1) {
    let order = window.localStorage.getItem('order')
    if (order !== 'undefined') {
      order = JSON.parse(order)
      if (window.localStorage.getItem('result') === 'success') {
        if (order && order.type) {
          next(order.type === 'real' ? { name: 'RealResult' } : { name: 'VirtualResult' })
        } else {
          next()
        }
      } else {
        next()
      }
    } else {
      next()
    }
  }
  next()
})

export default router
